module.exports = __webpack_public_path__ + "img/float_tidal.bc38b72b.png";